// extracted by mini-css-extract-plugin
module.exports = {"horizontal-bar":"_2CgU9YF","horizontalBar":"_2CgU9YF"};